import { Customer } from '@/types'
import { Button, Group, InputBase, Stack, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import { IMaskInput } from 'react-imask'

type CustomerFormValues = Pick<Customer, 'first_name' | 'last_name' | 'phone_number' | 'email' | 'address'>

export default function CustomerForm({
  onSubmit,
  initialValues,
  submitLabel = 'Créer le client',
}: {
  onSubmit: (customer: CustomerFormValues) => void
  initialValues?: Partial<CustomerFormValues>
  submitLabel?: string
}) {
  const form = useForm<CustomerFormValues>({
    initialValues: {
      first_name: initialValues?.first_name ?? '',
      last_name: initialValues?.last_name ?? '',
      phone_number: initialValues?.phone_number ?? '',
      email: initialValues?.email ?? '',
      address: initialValues?.address ?? '',
    },
  })

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="md">
        <Group grow align="flex-start">
          <TextInput label="Prénom" {...form.getInputProps('first_name')} required data-autofocus />
          <TextInput label="Nom" {...form.getInputProps('last_name')} required />
        </Group>

        <Group grow align="flex-start">
          <InputBase
            component={IMaskInput}
            mask="00 00 00 00 00"
            label="Téléphone"
            placeholder="06 00 00 00 00"
            {...form.getInputProps('phone_number')}
            required
          />
          <TextInput label="Email" placeholder="email@exemple.com" {...form.getInputProps('email')} />
        </Group>

        <TextInput label="Adresse" placeholder="123 rue de la Paix" {...form.getInputProps('address')} />

        <Button type="submit" radius="md" fullWidth size="md">
          {submitLabel}
        </Button>
      </Stack>
    </form>
  )
}
